import { getConfiguration, verifyExtend } from "./extend-utils.js";
import { initCartOffer } from "./extend-cart.js";

window.addEventListener('DOMContentLoaded', () => {
    try {
        const storeId = 'd1bde0f7-3340-43b9-940a-6f7b38687679';
        const environment = 'production';

        window.Extend.config({ storeId, environment});

        const config = getConfiguration();

        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
    } catch (err) {
        if (sessionStorage.getItem('extend.debug'))
            console.error(err);
    }
});